import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import css from './archive-button.css'

const ArchiveButton = ({
  active,
  convoId,
  convoTabIndex,
  handleArchiveButtonClick,
}) => {
  const btnClasses = cx(
    css.btn,
    { [css.disabled]: (convoTabIndex && active) },
  )

  const btnText = () => {
    if (active && convoTabIndex) {
      return 'In Inbox'
    } else if (active) {
      return 'Move to Archive'
    }
    return 'Move to Inbox'
  }

  return (
    <div className={css.container}>
      <button
        className={btnClasses}
        onClick={() => handleArchiveButtonClick(!active, convoId)}
      >
        {btnText()}
      </button>
    </div>
  )
}

ArchiveButton.propTypes = {
  active: PropTypes.bool.isRequired,
  convoId: PropTypes.number.isRequired,
  convoTabIndex: PropTypes.number.isRequired,
  handleArchiveButtonClick: PropTypes.func.isRequired,
}

export default ArchiveButton



// WEBPACK FOOTER //
// ./src/components/Messages/Header/ArchiveButton.js